// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"9ed75933","364":"31e02317","759":"973b666c","861":"e8bf6314"}[chunkId] + ".chunk.js";
};